/**
 * This function, `isSurvicatePage`, is used to determine whether a specified page, is on the list of Survicate Enabled pages.
 * The function takes in an object with two arguments: `path` and `locale`.
 *
 *  The function operates by removing the locale from the path and checking if the sanitized path matches with either
 * 'beratung-vereinbaren' or 'consultation'.
 *
 * Only pages With /locale/PAGE_NAME/ will work!
 *
 * @param {string} path is the route or URL path that is being evaluated.
 * @param {UrlLocale} locale is an object of type UrlLocale,
 *
 * @returns {boolean} The end result of the function is a boolean value, which will be true if the page is a survey-enabled page, and false otherwise.
 */
import {type UrlLocaleEnum} from '../types/locale';

export function isSurvicatePage({path, locale}: {path: string; locale: UrlLocaleEnum}): boolean {
  const noPathLocale = path.replace(`/${locale}/`, '').replace('/', '');

  return ['beratung-vereinbaren', 'consultation'].some(el => el === noPathLocale);
}
